import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { Auth } from "aws-amplify";

// Types
import { EffectiveProfileProps, ProfileListItem } from "../../types";

// Helpers
import { API_URL } from "../../consts";

export const profilesApi = createApi({
  reducerPath: "profiles",
  baseQuery: fetchBaseQuery({
    baseUrl: API_URL,
    async prepareHeaders(headers: Headers): Promise<Headers> {
      const session = await Auth.currentSession();
      const jwtToken = session.getIdToken().getJwtToken();

      headers.set("Authorization", `Bearer ${jwtToken}`);

      return headers;
    },
  }),
  tagTypes: ["Profiles"],
  endpoints: (builder) => ({
    effectiveProfile: builder.query<EffectiveProfileProps, void>({
      query: () =>
        `effectiveProfile`,
      providesTags: () => [{ type: "Profiles" }]
    }),
    profiles: builder.query<ProfileListItem[], void >({
      query: (  ) =>
        `profiles`,
      providesTags: () => [{ type: "Profiles" }]
    }),
  }),
});

export const {
  useEffectiveProfileQuery,
  useProfilesQuery
} = profilesApi;
